export const SKILL = [
  {
    id: 1,
    name: '.NET',
  },
  {
    id: 2,
    name: '3D Artist',
  },
  {
    id: 3,
    name: '3D Max',
  },
  {
    id: 4,
    name: 'ActionScript',
  },
  {
    id: 5,
    name: 'Agavi',
  },
  {
    id: 6,
    name: 'Agile',
  },
  {
    id: 7,
    name: 'Ajax',
  },
  {
    id: 8,
    name: 'Android',
  },
  {
    id: 9,
    name: 'AngularJS',
  },
  {
    id: 10,
    name: 'Antiryad Gx',
  },
  {
    id: 11,
    name: 'App Game Kit',
  },
  {
    id: 12,
    name: 'ASP.NET',
  },
  {
    id: 13,
    name: 'AutoCAD',
  },
  {
    id: 14,
    name: 'BattryTech',
  },
  {
    id: 15,
    name: 'Bootstrap',
  },
  {
    id: 16,
    name: 'Bridge Engineer',
  },
  {
    id: 17,
    name: 'C#',
  },
  {
    id: 18,
    name: 'C++',
  },
  {
    id: 19,
    name: 'Cacti',
  },
  {
    id: 20,
    name: 'CakePHP',
  },
  {
    id: 21,
    name: 'Ceph',
  },
  {
    id: 22,
    name: 'Cocoonjs',
  },
  {
    id: 23,
    name: 'Cocos2D',
  },
  {
    id: 24,
    name: 'CodeIgniter',
  },
  {
    id: 25,
    name: 'Construct 2',
  },
  {
    id: 26,
    name: 'CorelDRAW',
  },
  {
    id: 27,
    name: 'Corona',
  },
  {
    id: 28,
    name: 'CSS',
  },
  {
    id: 29,
    name: 'Designer',
  },
  {
    id: 30,
    name: 'Django',
  },
  {
    id: 31,
    name: 'Drupal',
  },
  {
    id: 32,
    name: 'Edgelib',
  },
  {
    id: 33,
    name: 'Elasticsearch',
  },
  {
    id: 34,
    name: 'Emo',
  },
  {
    id: 35,
    name: 'ERP',
  },
  {
    id: 36,
    name: 'Esenthel Engine',
  },
  {
    id: 37,
    name: 'FlightPHP',
  },
  {
    id: 38,
    name: 'FuelPHP',
  },
  {
    id: 39,
    name: 'Game',
  },
  {
    id: 40,
    name: 'Game Artist',
  },
  {
    id: 41,
    name: 'Game Editor',
  },
  {
    id: 42,
    name: 'GameMaker',
  },
  {
    id: 43,
    name: 'GameSalad',
  },
  {
    id: 44,
    name: 'Gideros',
  },
  {
    id: 45,
    name: 'Git',
  },
  {
    id: 46,
    name: 'Github',
  },
  {
    id: 47,
    name: 'GlusterFS',
  },
  {
    id: 48,
    name: 'HDFS',
  },
  {
    id: 49,
    name: 'HTML',
  },
  {
    id: 50,
    name: 'HTML5',
  },
  {
    id: 51,
    name: 'Illustrator',
  },
  {
    id: 52,
    name: 'iOS',
  },
  {
    id: 53,
    name: 'IT Helpdesk',
  },
  {
    id: 54,
    name: 'J2EE',
  },
  {
    id: 55,
    name: 'Java',
  },
  {
    id: 56,
    name: 'Javascript',
  },
  {
    id: 57,
    name: 'JMonkey',
  },
  {
    id: 58,
    name: 'Joomla',
  },
  {
    id: 59,
    name: 'JQuery',
  },
  {
    id: 60,
    name: 'JSON',
  },
  {
    id: 61,
    name: 'Knockout JS',
  },
  {
    id: 62,
    name: 'Laravel',
  },
  {
    id: 63,
    name: 'Libdx',
  },
  {
    id: 64,
    name: 'Linux',
  },
  {
    id: 65,
    name: 'LiveCode',
  },
  {
    id: 66,
    name: 'Lua',
  },
  {
    id: 67,
    name: 'Magento',
  },
  {
    id: 68,
    name: 'Manager',
  },
  {
    id: 69,
    name: 'MariaDB',
  },
  {
    id: 70,
    name: 'Marmalade',
  },
  {
    id: 71,
    name: 'Maya',
  },
  {
    id: 72,
    name: 'Memcached',
  },
  {
    id: 73,
    name: 'Microsoft Access',
  },
  {
    id: 74,
    name: 'MongoDB',
  },
  {
    id: 75,
    name: 'MonoGame',
  },
  {
    id: 76,
    name: 'MoSync',
  },
  {
    id: 77,
    name: 'MRTG',
  },
  {
    id: 78,
    name: 'MS SQL',
  },
  {
    id: 79,
    name: 'Multimedia Fusion 2',
  },
  {
    id: 80,
    name: 'MVC',
  },
  {
    id: 81,
    name: 'MVC5',
  },
  {
    id: 82,
    name: 'MySQL',
  },
  {
    id: 83,
    name: 'Nagios',
  },
  {
    id: 84,
    name: 'Nette',
  },
  {
    id: 85,
    name: 'Nginx',
  },
  {
    id: 86,
    name: 'NodeJS',
  },
  {
    id: 87,
    name: 'NoSQL',
  },
  {
    id: 88,
    name: 'Objective-C',
  },
  {
    id: 89,
    name: 'Odoo',
  },
  {
    id: 90,
    name: 'OOP',
  },
  {
    id: 91,
    name: 'Oracle',
  },
  {
    id: 92,
    name: 'Orx',
  },
  {
    id: 93,
    name: 'Papaya Social Game Engine',
  },
  {
    id: 94,
    name: 'Perl',
  },
  {
    id: 95,
    name: 'PhalconPHP',
  },
  {
    id: 96,
    name: 'Photoshop',
  },
  {
    id: 97,
    name: 'PHP',
  },
  {
    id: 98,
    name: 'PHPixie',
  },
  {
    id: 99,
    name: 'PlayCanvas',
  },
  {
    id: 100,
    name: 'PlayIR',
  },
  {
    id: 101,
    name: 'PopPHP',
  },
  {
    id: 102,
    name: 'PostgreSQL',
  },
  {
    id: 103,
    name: 'Product Manager',
  },
  {
    id: 104,
    name: 'Project Manager',
  },
  {
    id: 105,
    name: 'Python',
  },
  {
    id: 106,
    name: 'Redis',
  },
  {
    id: 107,
    name: 'REST API',
  },
  {
    id: 108,
    name: 'Riak',
  },
  {
    id: 109,
    name: 'Ruby on Rails',
  },
  {
    id: 110,
    name: 'SEM',
  },
  {
    id: 111,
    name: 'SEO',
  },
  {
    id: 112,
    name: 'Server-Side Scripting',
  },
  {
    id: 113,
    name: 'Sharepoint',
  },
  {
    id: 114,
    name: 'ShiVa',
  },
  {
    id: 115,
    name: 'ShiVa3D',
  },
  {
    id: 116,
    name: 'Signal R',
  },
  {
    id: 117,
    name: 'Simple MVC Framework',
  },
  {
    id: 118,
    name: 'Sketch',
  },
  {
    id: 119,
    name: 'Socket.io',
  },
  {
    id: 120,
    name: 'Sparrow',
  },
  {
    id: 121,
    name: 'SQL',
  },
  {
    id: 122,
    name: 'SQL Server',
  },
  {
    id: 123,
    name: 'Squid',
  },
  {
    id: 124,
    name: 'Starling',
  },
  {
    id: 125,
    name: 'Styncyl',
  },
  {
    id: 126,
    name: 'SVN',
  },
  {
    id: 127,
    name: 'Swift',
  },
  {
    id: 128,
    name: 'Symfony',
  },
  {
    id: 129,
    name: 'System Admin',
  },
  {
    id: 130,
    name: 'Tester',
  },
  {
    id: 132,
    name: 'UML',
  },
  {
    id: 133,
    name: 'Unity',
  },
  {
    id: 134,
    name: 'Unreal Development Kit',
  },
  {
    id: 135,
    name: 'UX/UI Design',
  },
  {
    id: 136,
    name: 'visual-basic',
  },
  {
    id: 137,
    name: 'WCF',
  },
  {
    id: 138,
    name: 'Websocket',
  },
  {
    id: 139,
    name: 'Windows Phone',
  },
  {
    id: 140,
    name: 'WordPress',
  },
  {
    id: 146,
    name: 'Leadership',
  },
  {
    id: 147,
    name: 'Teamwork',
  },
  {
    id: 148,
    name: 'Database',
  },
  {
    id: 149,
    name: 'IELTS',
  },
  {
    id: 150,
    name: 'Word',
  },
  {
    id: 151,
    name: 'Excel',
  },
  {
    id: 152,
    name: 'PowerPoint',
  },
  {
    id: 153,
    name: 'GMAT',
  },
  {
    id: 154,
    name: 'test cases',
  },
  {
    id: 155,
    name: 'test scripts',
  },
  {
    id: 156,
    name: 'test plan',
  },
  {
    id: 157,
    name: 'Google Analytics',
  },
  {
    id: 158,
    name: 'Google Webmaster tool',
  },
  {
    id: 159,
    name: 'iView',
  },
  {
    id: 160,
    name: 'iClick',
  },
  {
    id: 161,
    name: 'Facebook Ninja',
  },
  {
    id: 162,
    name: 'Rank tracker',
  },
  {
    id: 163,
    name: 'HMA',
  },
  {
    id: 164,
    name: 'Opencart',
  },
  {
    id: 165,
    name: 'Làm việc độc lập',
  },
  {
    id: 174,
    name: 'Giải quyết vấn đề',
  },
  {
    id: 181,
    name: 'Microsoft Office',
  },
  {
    id: 183,
    name: 'Kỹ năng lãnh đạo',
  },
  {
    id: 184,
    name: 'Lập kế hoạch',
  },
  {
    id: 187,
    name: 'Kỹ năng giao tiếp',
  },
  {
    id: 188,
    name: 'Làm việc nhóm',
  },
  {
    id: 189,
    name: 'Quản lý thời gian',
  },
  {
    id: 194,
    name: 'Copywriting',
  },
  {
    id: 198,
    name: 'Kỹ năng đàm phán',
  },
  {
    id: 202,
    name: 'Tổ chức sự kiện',
  },
  {
    id: 203,
    name: 'Market Research',
  },
  {
    id: 204,
    name: 'Telesales',
  },
  {
    id: 218,
    name: 'Kĩ năng phân tích tổng hợp',
  },
  {
    id: 219,
    name: 'Kỹ năng lắng nghe',
  },
  {
    id: 220,
    name: 'Docker',
  },
  {
    id: 223,
    name: 'Redux',
  },
  {
    id: 230,
    name: 'Planning',
  },
  {
    id: 238,
    name: 'Angular 2',
  },
  {
    id: 239,
    name: 'LESS',
  },
  {
    id: 240,
    name: 'SASS',
  },
  {
    id: 245,
    name: 'After Effect',
  },
  {
    id: 249,
    name: 'Google Adwords',
  },
  {
    id: 254,
    name: 'Marketing',
  },
  {
    id: 259,
    name: 'R&D',
  },
  {
    id: 260,
    name: 'Project Management',
  },
  {
    id: 263,
    name: 'cs-cart',
  },
  {
    id: 264,
    name: 'bitrix',
  },
  {
    id: 268,
    name: 'Biên tập',
  },
  {
    id: 276,
    name: 'React Native',
  },
  {
    id: 289,
    name: 'webpack',
  },
  {
    id: 291,
    name: 'babel',
  },
  {
    id: 293,
    name: 'HSK',
  },
  {
    id: 297,
    name: 'CPA',
  },
  {
    id: 299,
    name: 'Tiếng Trung',
  },
  {
    id: 321,
    name: 'SCRUM',
  },
  {
    id: 322,
    name: 'evm',
  },
  {
    id: 343,
    name: 'Dựng phim',
  },
  {
    id: 363,
    name: 'Tiếng Nhật',
  },
  {
    id: 367,
    name: 'QC/QA',
  },
  {
    id: 392,
    name: 'Windows Server',
  },
  {
    id: 393,
    name: 'Oracle DataGuard',
  },
  {
    id: 397,
    name: 'C&B',
  },
  {
    id: 398,
    name: 'LAN',
  },
  {
    id: 399,
    name: 'WAN',
  },
  {
    id: 401,
    name: 'CRM',
  },
  {
    id: 410,
    name: 'AFC',
  },
  {
    id: 411,
    name: 'ACCA',
  },
  {
    id: 415,
    name: 'AI',
  },
  {
    id: 417,
    name: 'VR',
  },
  {
    id: 418,
    name: 'Graphic design',
  },
  {
    id: 448,
    name: 'Java GUI Framework',
  },
  {
    id: 449,
    name: 'Oracle Database',
  },
  {
    id: 454,
    name: 'UI',
  },
  {
    id: 467,
    name: 'GIS',
  },
  {
    id: 468,
    name: 'NPI',
  },
  {
    id: 469,
    name: 'UX',
  },
  {
    id: 470,
    name: 'kafka',
  },
  {
    id: 474,
    name: 'Analytics',
  },
  {
    id: 476,
    name: 'etabs',
  },
  {
    id: 479,
    name: 'AIX platform',
  },
  {
    id: 480,
    name: 'IBM HTTP Server',
  },
  {
    id: 481,
    name: 'Business Process Analysis',
  },
  {
    id: 482,
    name: 'Tiếng Nhật N3',
  },
  {
    id: 486,
    name: 'Adobe Photoshop',
  },
  {
    id: 490,
    name: 'AWS',
  },
  {
    id: 511,
    name: 'ORM',
  },
  {
    id: 529,
    name: 'TOEIC',
  },
  {
    id: 530,
    name: 'Kỹ năng Thuyết phục',
  },
  {
    id: 534,
    name: 'Tiếng Anh giao tiếp',
  },
  {
    id: 549,
    name: 'Automation Test',
  },
  {
    id: 579,
    name: 'Struts',
  },
  {
    id: 617,
    name: 'Revit',
  },
  {
    id: 639,
    name: 'Sketchup',
  },
  {
    id: 679,
    name: 'CSS3',
  },
  {
    id: 681,
    name: 'OTC',
  },
  {
    id: 720,
    name: 'VB.NET',
  },
  {
    id: 723,
    name: '.NET Framework',
  },
  {
    id: 724,
    name: 'MSSQL',
  },
  {
    id: 725,
    name: 'LinQ',
  },
  {
    id: 732,
    name: 'Facebook Ads',
  },
  {
    id: 733,
    name: 'Zalo ads',
  },
  {
    id: 735,
    name: 'SQLite',
  },
  {
    id: 740,
    name: 'Elixir',
  },
  {
    id: 744,
    name: 'TESOL',
  },
  {
    id: 746,
    name: 'TOEFL',
  },
  {
    id: 747,
    name: 'Quản lý nhóm ',
  },
  {
    id: 770,
    name: 'Tiếng Anh thành thạo',
  },
  {
    id: 771,
    name: 'Kỹ năng thuyết trình',
  },
  {
    id: 772,
    name: 'Tư duy hệ thống ',
  },
  {
    id: 779,
    name: 'ASP',
  },
  {
    id: 795,
    name: 'Tiếng Nhật N3',
  },
  {
    id: 913,
    name: 'Crystal Reports',
  },
  {
    id: 922,
    name: 'Hibernate',
  },
  {
    id: 1028,
    name: 'Kỹ năng quản lý',
  },
  {
    id: 1099,
    name: 'LabVIEW',
  },
  {
    id: 1153,
    name: 'RD',
  },
  {
    id: 1157,
    name: 'Tiếng Nhật N2',
  },
  {
    id: 1179,
    name: 'Qt Framework',
  },
  {
    id: 1182,
    name: 'Biên phiên dịch tiếng Trung',
  },
  {
    id: 1186,
    name: 'pfSense',
  },
  {
    id: 1188,
    name: 'Tin học văn phòng',
  },
  {
    id: 1206,
    name: 'DNS',
  },
  {
    id: 1246,
    name: 'Biên tập Video',
  },
  {
    id: 1248,
    name: 'SolidWorks',
  },
  {
    id: 1255,
    name: 'Oracle PL/SQL',
  },
  {
    id: 1269,
    name: 'UIKit',
  },
  {
    id: 1270,
    name: 'Core Data',
  },
  {
    id: 1278,
    name: 'Blockchain',
  },
  {
    id: 1282,
    name: 'Sony Vegas',
  },
  {
    id: 1338,
    name: 'Tiếng Nga giao tiếp',
  },
  {
    id: 1397,
    name: 'Maven',
  },
  {
    id: 1405,
    name: 'Kubernetes',
  },
  {
    id: 1412,
    name: 'Cocos2d-x',
  },
  {
    id: 1413,
    name: 'XCode',
  },
  {
    id: 1414,
    name: 'Visual Studio',
  },
  {
    id: 1415,
    name: 'Cocos Studio',
  },
  {
    id: 1451,
    name: 'Tiếng Nhật N4',
  },
  {
    id: 1523,
    name: 'CAD/CAE',
  },
  {
    id: 1524,
    name: 'Angular 4',
  },
  {
    id: 1589,
    name: 'Javascript Framework',
  },
  {
    id: 1739,
    name: 'Web API',
  },
  {
    id: 1747,
    name: 'TypeScript',
  },
  {
    id: 1753,
    name: 'Stopmotion',
  },
  {
    id: 1754,
    name: 'Storyboad',
  },
  {
    id: 1762,
    name: 'Message Queue',
  },
  {
    id: 1847,
    name: 'Adobe Illustrator',
  },
  {
    id: 1909,
    name: 'Scala',
  },
  {
    id: 1919,
    name: 'Chart.JS',
  },
  {
    id: 1929,
    name: 'Google APIs',
  },
  {
    id: 1941,
    name: 'DI',
  },
  {
    id: 1942,
    name: 'Web Socket',
  },
  {
    id: 1950,
    name: 'ADO.NET',
  },
  {
    id: 1962,
    name: 'Hitosoft',
  },
  {
    id: 1971,
    name: 'MVC4',
  },
  {
    id: 1989,
    name: 'Realm',
  },
  {
    id: 1994,
    name: 'OpenGL',
  },
  {
    id: 1996,
    name: 'Android SDK',
  },
  {
    id: 1997,
    name: 'Android ADT',
  },
  {
    id: 2008,
    name: 'CentOS',
  },
  {
    id: 2009,
    name: 'Shell script',
  },
  {
    id: 2010,
    name: 'Adobe Audition',
  },
  {
    id: 2011,
    name: 'DaVinci',
  },
  {
    id: 2016,
    name: 'Adobe Premier',
  },
  {
    id: 2024,
    name: 'Moho',
  },
  {
    id: 2046,
    name: 'SDLC',
  },
  {
    id: 2086,
    name: 'Angular 6',
  },
  {
    id: 2098,
    name: 'TOPIK 4',
  },
  {
    id: 2123,
    name: 'COBOL',
  },
  {
    id: 2129,
    name: 'Dịch thuật tiếng Trung',
  },
  {
    id: 2151,
    name: 'Animation',
  },
  {
    id: 2177,
    name: 'Apache',
  },
  {
    id: 2187,
    name: 'Scraping',
  },
  {
    id: 2199,
    name: 'Kendo UI',
  },
  {
    id: 2212,
    name: 'Archicad',
  },
  {
    id: 2235,
    name: 'Lotus Notes',
  },
  {
    id: 2244,
    name: 'Slim PHP',
  },
  {
    id: 2274,
    name: 'JSF',
  },
  {
    id: 2308,
    name: 'VLAN',
  },
  {
    id: 2309,
    name: 'Routing IP',
  },
  {
    id: 2320,
    name: 'Financial office',
  },
  {
    id: 2321,
    name: 'Advertising',
  },
  {
    id: 2322,
    name: 'Vẽ 3D',
  },
  {
    id: 2332,
    name: 'Junit',
  },
  {
    id: 2340,
    name: 'Magento 2',
  },
  {
    id: 2341,
    name: 'Angular JS',
  },
  {
    id: 2355,
    name: 'Tiếng Nhật N1',
  },
  {
    id: 2392,
    name: 'VueJS',
  },
  {
    id: 2393,
    name: 'MS Outlook',
  },
  {
    id: 2394,
    name: 'XHTML',
  },
  {
    id: 2397,
    name: 'ISA',
  },
  {
    id: 2398,
    name: 'DFS',
  },
  {
    id: 2406,
    name: 'MCSA',
  },
  {
    id: 2407,
    name: 'MCSE',
  },
  {
    id: 2415,
    name: 'CCBA',
  },
  {
    id: 2416,
    name: 'CBAP',
  },
  {
    id: 2421,
    name: 'Cad',
  },
  {
    id: 2449,
    name: 'Kỹ năng phỏng vấn',
  },
  {
    id: 2466,
    name: 'counselor',
  },
  {
    id: 2472,
    name: 'debug',
  },
  {
    id: 2473,
    name: 'IOT',
  },
  {
    id: 2484,
    name: 'FileMaker',
  },
  {
    id: 2493,
    name: 'ReactJS',
  },
  {
    id: 2494,
    name: 'ExpressJS',
  },
  {
    id: 2495,
    name: 'MeanJS',
  },
  {
    id: 2497,
    name: 'Restify',
  },
  {
    id: 2504,
    name: 'Kỹ năng sư phạm',
  },
  {
    id: 2548,
    name: 'PMP',
  },
  {
    id: 2549,
    name: 'PMF',
  },
  {
    id: 2550,
    name: 'CSM',
  },
  {
    id: 2551,
    name: 'PSM',
  },
  {
    id: 2575,
    name: 'Xử lý tình huống',
  },
  {
    id: 2611,
    name: 'TBA',
  },
  {
    id: 2612,
    name: 'MFĐ',
  },
  {
    id: 2613,
    name: 'UPS',
  },
  {
    id: 2625,
    name: 'Juniper',
  },
  {
    id: 2644,
    name: 'Tiếng Nhật N2 - N1',
  },
  {
    id: 2685,
    name: 'N3',
  },
  {
    id: 2686,
    name: 'N1',
  },
  {
    id: 2690,
    name: 'Biên phiên dịch tiếng Hàn',
  },
  {
    id: 2706,
    name: 'Biên phiên dịch tiếng Anh',
  },
  {
    id: 2713,
    name: 'Kỹ năng phân tích kinh doanh',
  },
  {
    id: 2762,
    name: 'Angular',
  },
  {
    id: 2847,
    name: 'Kỹ năng bơi lội',
  },
  {
    id: 2888,
    name: 'Meteor',
  },
  {
    id: 2913,
    name: 'Smartfox',
  },
  {
    id: 2922,
    name: 'Kỹ năng bán hàng',
  },
  {
    id: 2953,
    name: 'kỹ năng đào tạo',
  },
  {
    id: 2972,
    name: 'HTTP/HTTPS',
  },
  {
    id: 2973,
    name: 'FTP',
  },
  {
    id: 3002,
    name: 'VNACCS',
  },
  {
    id: 3012,
    name: 'Framework Django',
  },
  {
    id: 3013,
    name: 'Lái xe',
  },
  {
    id: 3015,
    name: 'MVP',
  },
  {
    id: 3016,
    name: 'MVV',
  },
  {
    id: 3018,
    name: 'Avid Media Composer',
  },
  {
    id: 3019,
    name: 'Lightworks',
  },
  {
    id: 3020,
    name: 'Final Cut',
  },
  {
    id: 3065,
    name: 'Content write',
  },
  {
    id: 3092,
    name: 'MES',
  },
  {
    id: 3097,
    name: 'Flutter',
  },
  {
    id: 3148,
    name: 'IELTS 6.',
  },
  {
    id: 3157,
    name: 'Cimatron',
  },
  {
    id: 3186,
    name: 'GUI',
  },
  {
    id: 3229,
    name: 'Đàm phán thương lượng',
  },
  {
    id: 3240,
    name: 'HSK4',
  },
  {
    id: 3316,
    name: 'DB2',
  },
  {
    id: 3324,
    name: 'Avr',
  },
  {
    id: 3329,
    name: 'Angular 1',
  },
  {
    id: 3357,
    name: 'Kỹ năng tuyển dụng',
  },
  {
    id: 3364,
    name: 'Kỹ năng giảng dạy',
  },
  {
    id: 3421,
    name: 'JLPT  N3',
  },
  {
    id: 3509,
    name: 'HSK5',
  },
  {
    id: 3563,
    name: 'ETAB',
  },
  {
    id: 3663,
    name: 'Fireframe',
  },
  {
    id: 3664,
    name: 'ASTM',
  },
  {
    id: 3683,
    name: 'phân tích số liệu',
  },
  {
    id: 3759,
    name: 'Tiếng Hàn',
  },
  {
    id: 3817,
    name: 'UCD',
  },
  {
    id: 3818,
    name: 'UID',
  },
  {
    id: 3842,
    name: 'Tiếng Pháp',
  },
  {
    id: 3861,
    name: 'Kỹ năng đàm phán',
  },
  {
    id: 4001,
    name: 'Business Analyst',
  },
  {
    id: 4003,
    name: 'kỹ năng điều tra',
  },
  {
    id: 4009,
    name: 'Unix',
  },
  {
    id: 4079,
    name: 'Kỹ năng báo cáo',
  },
  {
    id: 4110,
    name: 'Sales',
  },
  {
    id: 4119,
    name: 'PR',
  },
  {
    id: 4129,
    name: 'Tìm kiếm khách hàng',
  },
  {
    id: 4131,
    name: 'Tư vấn',
  },
  {
    id: 4151,
    name: 'Kỹ năng quản lý công việc',
  },
  {
    id: 4165,
    name: 'Sales online',
  },
  {
    id: 4168,
    name: 'PQA',
  },
  {
    id: 4169,
    name: 'QA',
  },
  {
    id: 4195,
    name: 'PLC',
  },
  {
    id: 4209,
    name: 'Oracle SQL',
  },
  {
    id: 4213,
    name: 'CCNA',
  },
  {
    id: 4225,
    name: 'Flash',
  },
  {
    id: 4289,
    name: 'LPI',
  },
  {
    id: 4335,
    name: 'Tư duy logic',
  },
  {
    id: 4338,
    name: 'Adobe After Effects',
  },
  {
    id: 4339,
    name: 'Adobe Dreamweaver',
  },
  {
    id: 4340,
    name: 'Adobe InDesign',
  },
  {
    id: 4363,
    name: 'Biên phiên dịch Tiếng Nhật',
  },
  {
    id: 4466,
    name: 'Jenkins',
  },
  {
    id: 4574,
    name: 'MS Offices ',
  },
  {
    id: 4575,
    name: 'Misa',
  },
  {
    id: 4587,
    name: 'Tiếng Anh đọc hiểu',
  },
  {
    id: 4699,
    name: 'Adobe Premiere Pro',
  },
  {
    id: 4715,
    name: 'Golang',
  },
  {
    id: 4738,
    name: 'Unity 3D',
  },
  {
    id: 4797,
    name: 'Cadewa',
  },
  {
    id: 4801,
    name: 'Kotlin',
  },
  {
    id: 4808,
    name: 'Jira',
  },
  {
    id: 4839,
    name: 'Tiếng Anh cơ bản',
  },
  {
    id: 4845,
    name: 'Tiếng Anh trung cấp',
  },
  {
    id: 4866,
    name: 'ATSM',
  },
  {
    id: 4867,
    name: 'ASME',
  },
  {
    id: 4883,
    name: 'Lightroom',
  },
  {
    id: 4919,
    name: 'Alige',
  },
  {
    id: 4920,
    name: 'VMWare',
  },
  {
    id: 4927,
    name: 'VB6',
  },
  {
    id: 4928,
    name: 'Zoho Desk',
  },
  {
    id: 4972,
    name: 'Big Data',
  },
  {
    id: 4973,
    name: 'NLP',
  },
  {
    id: 4982,
    name: 'RSpec',
  },
  {
    id: 4983,
    name: 'Devise',
  },
  {
    id: 4984,
    name: ' TDD',
  },
  {
    id: 4985,
    name: 'CI',
  },
  {
    id: 4986,
    name: 'Mocking',
  },
  {
    id: 4991,
    name: 'Exploit',
  },
  {
    id: 4994,
    name: 'Eclipse',
  },
  {
    id: 5001,
    name: 'OOD',
  },
  {
    id: 5009,
    name: 'LAMP',
  },
  {
    id: 5010,
    name: 'LEMP',
  },
  {
    id: 5011,
    name: 'VPSSIM',
  },
  {
    id: 5016,
    name: 'Ubuntu',
  },
  {
    id: 5034,
    name: 'Objective C',
  },
  {
    id: 5104,
    name: 'IRP',
  },
  {
    id: 5112,
    name: 'SOA',
  },
  {
    id: 5189,
    name: 'Gerber',
  },
  {
    id: 5190,
    name: 'Lectra',
  },
  {
    id: 5305,
    name: 'Negotiation Skill',
  },
  {
    id: 5363,
    name: 'Tiếng Thái',
  },
  {
    id: 5560,
    name: 'Spring',
  },
  {
    id: 5719,
    name: 'CAD 2D',
  },
  {
    id: 5743,
    name: 'Fast',
  },
  {
    id: 5744,
    name: 'Amis',
  },
  {
    id: 5777,
    name: 'Angular 5',
  },
  {
    id: 5788,
    name: 'Apache Spark ',
  },
  {
    id: 5798,
    name: 'HMTL5',
  },
  {
    id: 5799,
    name: 'Figma',
  },
  {
    id: 5866,
    name: 'JET',
  },
  {
    id: 6724,
    name: 'Intermedidate English',
  },
  {
    id: 6820,
    name: 'ABAP',
  },
  {
    id: 6929,
    name: 'Tensorflow',
  },
  {
    id: 6932,
    name: 'Pytorch',
  },
  {
    id: 6939,
    name: 'Zbrush',
  },
  {
    id: 6940,
    name: 'Sculpt',
  },
  {
    id: 7198,
    name: 'Spring Framework',
  },
  {
    id: 7199,
    name: 'Spring Boot',
  },
  {
    id: 7323,
    name: 'BPMN',
  },
  {
    id: 7660,
    name: 'Phát triển thị trường',
  },
  {
    id: 8223,
    name: 'TCP/IP',
  },
  {
    id: 9879,
    name: 'English',
  },
  {
    id: 10007,
    name: 'HSK 6',
  },
  {
    id: 10035,
    name: 'IELTS 7.0',
  },
  {
    id: 10157,
    name: 'JLPT N2',
  },
  {
    id: 11598,
    name: 'Ruby',
  },
  {
    id: 11604,
    name: 'Tiếng Đức',
  },
  {
    id: 11605,
    name: 'Tiếng Ý',
  },
  {
    id: 11606,
    name: 'Tiếng Ả Rập',
  },
  {
    id: 11607,
    name: 'Tiếng Bồ Đào Nha',
  },
  {
    id: 11608,
    name: 'Tiếng Tây Ban Nha',
  },
  {
    id: 12147,
    name: 'Tiếng Anh',
  },
  {
    id: 14473,
    name: 'Adobe Premiere',
  },
  {
    id: 17180,
    name: ' Full Stack',
  },
  {
    id: 17729,
    name: 'XML',
  },
  {
    id: 17741,
    name: 'AXure',
  },
  {
    id: 17831,
    name: 'TOEIC 600',
  },
  {
    id: 21065,
    name: 'JLPT N4',
  },
  {
    id: 24699,
    name: 'JLPT N1',
  },
  {
    id: 24738,
    name: 'IELTS 7.5',
  },
  {
    id: 26442,
    name: 'Tiếng Indonesia',
  },
  {
    id: 28547,
    name: 'TOEIC 550',
  },
  {
    id: 29317,
    name: 'TOEIC 850',
  },
  {
    id: 45197,
    name: 'IELTS 8.5',
  },
  {
    id: 46772,
    name: 'HKS5',
  },
  {
    id: 46773,
    name: 'HSK6',
  },
  {
    id: 47976,
    name: 'IELTS 6.5',
  },
  {
    id: 47977,
    name: 'TOEIC 650',
  },
  {
    id: 47978,
    name: 'Tiếng Anh B2',
  },
  {
    id: 48980,
    name: 'IELTS 8.0',
  },
  {
    id: 65382,
    name: 'Performance Marketing',
  },
  {
    id: 65383,
    name: 'Marketing Online',
  },
  {
    id: 65397,
    name: 'Programming',
  },
  {
    id: 65400,
    name: 'Xây dựng đội nhóm',
  },
  {
    id: 65412,
    name: 'Excel cơ bản',
  },
  {
    id: 65437,
    name: 'API',
  },
  {
    id: 65447,
    name: 'CI/CD',
  },
  {
    id: 65454,
    name: 'Adobe',
  },
  {
    id: 65456,
    name: 'Quay dựng',
  },
  {
    id: 65467,
    name: 'Game Balance',
  },
  {
    id: 65468,
    name: 'Game Design',
  },
  {
    id: 65469,
    name: 'Event Planning',
  },
  {
    id: 65470,
    name: 'Public Speaking',
  },
  {
    id: 65472,
    name: 'Business Development',
  },
  {
    id: 65473,
    name: 'Communication',
  },
  {
    id: 65495,
    name: 'zalo',
  },
  {
    id: 65496,
    name: 'facebook',
  },
  {
    id: 65497,
    name: 'Content Writer',
  },
  {
    id: 65498,
    name: 'Sáng tạo nội dung',
  },
  {
    id: 65506,
    name: 'Phân tích công việc',
  },
  {
    id: 65509,
    name: 'Windows',
  },
  {
    id: 65510,
    name: 'Chịu áp lực cao',
  },
  {
    id: 65513,
    name: 'Direct Sale',
  },
  {
    id: 65514,
    name: 'Design Thinking',
  },
  {
    id: 65519,
    name: 'RESTful API',
  },
  {
    id: 65520,
    name: 'Back-End Web Development',
  },
  {
    id: 65521,
    name: 'RabbitMQ',
  },
  {
    id: 65522,
    name: 'Setup hệ thống',
  },
  {
    id: 65523,
    name: 'Nghiên cứu',
  },
  {
    id: 65524,
    name: 'Tổ chức công việc',
  },
  {
    id: 65525,
    name: 'Nhanh nhẹn',
  },
  {
    id: 65529,
    name: 'Cẩn thận',
  },
  {
    id: 65530,
    name: 'Nhiệt tình',
  },
  {
    id: 65531,
    name: 'Tự tin',
  },
  {
    id: 65532,
    name: 'Xây dựng mối quan hệ',
  },
  {
    id: 65539,
    name: 'Thiết kế đồ họa',
  },
  {
    id: 65540,
    name: 'Cởi mở',
  },
  {
    id: 65541,
    name: 'Creativity',
  },
  {
    id: 65542,
    name: 'People Management',
  },
  {
    id: 65543,
    name: 'Quản lý con người',
  },
  {
    id: 65544,
    name: 'Time Management',
  },
  {
    id: 65545,
    name: 'Persuasion',
  },
  {
    id: 65546,
    name: 'Khả năng thuyết phục',
  },
  {
    id: 65547,
    name: 'Emotional Intelligence (EQ)',
  },
  {
    id: 65548,
    name: 'Translation',
  },
  {
    id: 65549,
    name: 'Video Production',
  },
  {
    id: 65550,
    name: 'Corporate Communications',
  },
  {
    id: 65551,
    name: 'Industrial Design',
  },
  {
    id: 65552,
    name: 'Collaboration',
  },
  {
    id: 65553,
    name: 'Adaptability',
  },
  {
    id: 65554,
    name: 'Analytical Reasoning',
  },
  {
    id: 65555,
    name: 'Sales Leadership',
  },
  {
    id: 65556,
    name: 'Journalism',
  },
  {
    id: 65557,
    name: 'Competitive Strategies',
  },
  {
    id: 65558,
    name: 'Active listening',
  },
  {
    id: 65559,
    name: 'Writing',
  },
  {
    id: 65560,
    name: 'Nonverbal Communication',
  },
  {
    id: 65561,
    name: 'Consulting',
  },
  {
    id: 65562,
    name: 'Research',
  },
  {
    id: 65563,
    name: 'Problem-solving',
  },
  {
    id: 65564,
    name: 'Critical Thinking',
  },
  {
    id: 65565,
    name: 'Data Analysis',
  },
  {
    id: 65566,
    name: 'SEO/SEM',
  },
  {
    id: 65567,
    name: 'Social Media',
  },
  {
    id: 65568,
    name: 'Media Planning',
  },
  {
    id: 65569,
    name: 'Channel Marketing',
  },
  {
    id: 65570,
    name: 'Affiliate Marketing',
  },
  {
    id: 65571,
    name: 'Online Marketing',
  },
  {
    id: 65572,
    name: 'Strategic Planning',
  },
  {
    id: 65573,
    name: 'Delegating Tasks',
  },
  {
    id: 65574,
    name: 'Coaching',
  },
  {
    id: 65575,
    name: 'Giảng dạy',
  },
  {
    id: 65576,
    name: 'Negotiation',
  },
  {
    id: 65577,
    name: 'Đàm phán',
  },
  {
    id: 65579,
    name: 'Relationship Management',
  },
  {
    id: 65580,
    name: 'Cloud Computing',
  },
  {
    id: 65581,
    name: 'Data Presentation',
  },
  {
    id: 65582,
    name: 'Tech Support',
  },
  {
    id: 65583,
    name: 'UI/UX',
  },
  {
    id: 65584,
    name: 'Software Engineering',
  },
  {
    id: 65585,
    name: 'Mobile Development',
  },
  {
    id: 65586,
    name: 'Scientific Computing',
  },
  {
    id: 65588,
    name: 'Google',
  },
  {
    id: 66488,
    name: '.NET CLR',
  },
  {
    id: 66489,
    name: '.NET Compact Framework',
  },
  {
    id: 66490,
    name: '.com',
  },
  {
    id: 66491,
    name: '.htaccess',
  },
  {
    id: 66492,
    name: '10 Key',
  },
  {
    id: 66493,
    name: '1031 Exchanges',
  },
  {
    id: 66494,
    name: '1H NMR',
  },
  {
    id: 66495,
    name: '21 CFR',
  },
  {
    id: 66496,
    name: '21 CFR Part 11',
  },
  {
    id: 66497,
    name: '21st Century Skills',
  },
  {
    id: 66498,
    name: '2D graphics',
  },
  {
    id: 66499,
    name: '360 Degree Assessment',
  },
  {
    id: 66500,
    name: '360 Feedback',
  },
  {
    id: 66501,
    name: '3Com NBX',
  },
  {
    id: 66502,
    name: '3D Architectural Rendering',
  },
  {
    id: 66503,
    name: '3D GIS',
  },
  {
    id: 66504,
    name: '3D Graphics',
  },
  {
    id: 66505,
    name: '3D Modeling',
  },
  {
    id: 66506,
    name: '3D Rendering',
  },
  {
    id: 66507,
    name: '3D Scanning',
  },
  {
    id: 66508,
    name: '3D Seismic Interpretation',
  },
  {
    id: 66509,
    name: '3D Studio Max',
  },
  {
    id: 66510,
    name: '3D Studio Viz',
  },
  {
    id: 66511,
    name: '3D Visualization',
  },
  {
    id: 66512,
    name: '401k Rollovers',
  },
  {
    id: 66513,
    name: '4th Dimension',
  },
  {
    id: 66514,
    name: '5 Why',
  },
  {
    id: 66515,
    name: '5.1 Mixing',
  },
  {
    id: 66516,
    name: '960 Grid System',
  },
  {
    id: 66517,
    name: '@Task',
  },
  {
    id: 66518,
    name: 'A-GPS',
  },
  {
    id: 66519,
    name: 'A3 Thinking',
  },
  {
    id: 66520,
    name: 'AAAHC',
  },
  {
    id: 66521,
    name: 'AAC',
  },
  {
    id: 66522,
    name: 'AACR2',
  },
  {
    id: 66523,
    name: 'AAMS',
  },
  {
    id: 66524,
    name: 'AAP',
  },
  {
    id: 66525,
    name: 'AAR',
  },
  {
    id: 66526,
    name: 'AASHTO',
  },
  {
    id: 66527,
    name: 'AAT',
  },
  {
    id: 66528,
    name: 'AAUS Scientific Diver',
  },
  {
    id: 66529,
    name: 'ABAP Web Dynpro',
  },
  {
    id: 66530,
    name: 'ABAP-OO',
  },
  {
    id: 66531,
    name: 'ABB 800xA',
  },
  {
    id: 66532,
    name: 'ABBYY',
  },
  {
    id: 66533,
    name: 'ABBYY FineReader',
  },
  {
    id: 66534,
    name: 'ABC Analysis',
  },
  {
    id: 66535,
    name: 'ABC Flowcharter',
  },
  {
    id: 66536,
    name: 'ABCP',
  },
  {
    id: 66537,
    name: 'ABEL',
  },
  {
    id: 66538,
    name: 'ABI',
  },
  {
    id: 66539,
    name: 'ABLS',
  },
  {
    id: 66540,
    name: 'ABO Certified',
  },
  {
    id: 66541,
    name: 'ABR',
  },
  {
    id: 66542,
    name: 'ABS',
  },
  {
    id: 66543,
    name: 'ABV',
  },
  {
    id: 66544,
    name: 'AC Nielsen',
  },
  {
    id: 66545,
    name: 'ACAD',
  },
  {
    id: 66546,
    name: 'ACBS',
  },
  {
    id: 66547,
    name: 'ACD',
  },
  {
    id: 66548,
    name: 'ACD Management',
  },
  {
    id: 66549,
    name: 'ACDSee',
  },
  {
    id: 66550,
    name: 'ACE',
  },
  {
    id: 66551,
    name: 'ACE Certified',
  },
  {
    id: 66552,
    name: 'ACE Certified Personal Trainer',
  },
  {
    id: 66553,
    name: 'ACF2',
  },
  {
    id: 66554,
    name: 'ACFE',
  },
  {
    id: 66555,
    name: 'ACH',
  },
  {
    id: 66556,
    name: 'ACI Codes',
  },
  {
    id: 66557,
    name: 'ACIS',
  },
  {
    id: 66558,
    name: 'ACLS',
  },
  {
    id: 66559,
    name: 'ACLS Instruction',
  },
  {
    id: 66560,
    name: 'ACMS',
  },
  {
    id: 66561,
    name: 'ACOA',
  },
  {
    id: 66562,
    name: 'ACORD',
  },
  {
    id: 66563,
    name: 'ACP',
  },
  {
    id: 66564,
    name: 'ACPI',
  },
  {
    id: 66565,
    name: 'ACR',
  },
  {
    id: 66566,
    name: 'ACSA',
  },
  {
    id: 66567,
    name: 'ACSC',
  },
  {
    id: 66568,
    name: 'ACSLS',
  },
  {
    id: 66569,
    name: 'ACSM',
  },
  {
    id: 66570,
    name: 'ACSM Health Fitness',
  },
  {
    id: 66571,
    name: 'ACSP',
  },
  {
    id: 66572,
    name: 'ACSR',
  },
  {
    id: 66573,
    name: 'ACSS',
  },
  {
    id: 66574,
    name: 'ACT CRM',
  },
  {
    id: 66575,
    name: 'ADA Compliance',
  },
  {
    id: 66576,
    name: 'ADABAS',
  },
  {
    id: 66577,
    name: 'ADB',
  },
  {
    id: 66578,
    name: 'ADB Adapter',
  },
  {
    id: 66579,
    name: 'ADCs',
  },
  {
    id: 66580,
    name: 'ADDIE',
  },
  {
    id: 66581,
    name: 'ADDM',
  },
  {
    id: 66582,
    name: 'ADE',
  },
  {
    id: 66583,
    name: 'ADEA',
  },
  {
    id: 66584,
    name: 'ADF',
  },
  {
    id: 66585,
    name: 'ADFS',
  },
  {
    id: 66586,
    name: 'ADFS 2.0',
  },
  {
    id: 66587,
    name: 'ADHD Coaching',
  },
  {
    id: 66710,
    name: 'API 510',
  },
  {
    id: 66712,
    name: 'API 653',
  },
  {
    id: 66714,
    name: 'API Development',
  },
  {
    id: 66715,
    name: 'API Testing',
  },
  {
    id: 66747,
    name: 'ASAP',
  },
  {
    id: 66885,
    name: 'Accountants',
  },
  {
    id: 66886,
    name: 'Accounting',
  },
  {
    id: 66887,
    name: 'Accounts Payable',
  },
  {
    id: 66889,
    name: 'Accounts Receivable',
  },
  {
    id: 67001,
    name: 'Adobe Design Programs',
  },
  {
    id: 67103,
    name: 'Agile Environment',
  },
  {
    id: 67108,
    name: 'Agile Testing',
  },
  {
    id: 67293,
    name: 'Analytical Skills',
  },
  {
    id: 67455,
    name: 'Architectural Illustration',
  },
  {
    id: 67511,
    name: 'Aruba Wireless',
  },
  {
    id: 67928,
    name: 'Basic HTML',
  },
  {
    id: 68532,
    name: 'CAPA',
  },
  {
    id: 68738,
    name: 'CNC',
  },
  {
    id: 68739,
    name: 'CNC Machine',
  },
  {
    id: 68740,
    name: 'CNC Manufacturing',
  },
  {
    id: 68743,
    name: 'CNC Programing',
  },
  {
    id: 68818,
    name: 'CRM Program Management',
  },
  {
    id: 68908,
    name: 'Cache Coherency',
  },
  {
    id: 68909,
    name: 'Cache Object Script',
  },
  {
    id: 68959,
    name: 'Camtasia',
  },
  {
    id: 69562,
    name: 'Computer Vision',
  },
  {
    id: 69670,
    name: 'Core Java',
  },
  {
    id: 69776,
    name: 'Creative Writing',
  },
  {
    id: 69830,
    name: 'Cross-cultural Communication Skills',
  },
  {
    id: 69859,
    name: 'Crypto',
  },
  {
    id: 69915,
    name: 'Custom Facebook Pages',
  },
  {
    id: 69943,
    name: 'Customer Service',
  },
  {
    id: 70250,
    name: 'Dart',
  },
  {
    id: 70259,
    name: 'Data Backup Solutions',
  },
  {
    id: 70269,
    name: 'Data Domain',
  },
  {
    id: 70301,
    name: 'Database Marketing',
  },
  {
    id: 70519,
    name: 'Digital Art',
  },
  {
    id: 70544,
    name: 'Digital Media',
  },
  {
    id: 70747,
    name: 'Dreamweaver',
  },
  {
    id: 71028,
    name: 'ERP Software',
  },
  {
    id: 71615,
    name: 'Excel Pivot',
  },
  {
    id: 71776,
    name: 'FIFO',
  },
  {
    id: 72089,
    name: 'Final Cut Pro',
  },
  {
    id: 72093,
    name: 'Finance',
  },
  {
    id: 72335,
    name: 'Food Quality',
  },
  {
    id: 72373,
    name: 'Foundation Certificate in IT Service Management',
  },
  {
    id: 72374,
    name: 'Foundation Design',
  },
  {
    id: 72432,
    name: 'Front-end',
  },
  {
    id: 72588,
    name: 'GMP',
  },
  {
    id: 72806,
    name: 'German Teaching',
  },
  {
    id: 72807,
    name: 'German Translation',
  },
  {
    id: 73045,
    name: 'Group Purchasing',
  },
  {
    id: 73429,
    name: 'Heroku',
  },
  {
    id: 74020,
    name: 'IT Recruitment',
  },
  {
    id: 74092,
    name: 'Illustration',
  },
  {
    id: 74118,
    name: 'Import/Export Operations',
  },
  {
    id: 74124,
    name: 'InDesign',
  },
  {
    id: 74150,
    name: 'Indirect Purchasing',
  },
  {
    id: 74336,
    name: 'Internet Explorer',
  },
  {
    id: 74346,
    name: 'Interviews',
  },
  {
    id: 74486,
    name: 'JMeter',
  },
  {
    id: 74495,
    name: 'JPA',
  },
  {
    id: 74557,
    name: 'Java Web Services',
  },
  {
    id: 74563,
    name: 'JavaScript Libraries',
  },
  {
    id: 75349,
    name: 'Load Testing',
  },
  {
    id: 75723,
    name: 'Mac OS X Server',
  },
  {
    id: 75833,
    name: 'Manual Testing',
  },
  {
    id: 76095,
    name: 'Microsoft CRM',
  },
  {
    id: 76097,
    name: 'Microsoft Certified Technology',
  },
  {
    id: 76101,
    name: 'Microsoft Dynamics AX',
  },
  {
    id: 76106,
    name: 'Microsoft Excel',
  },
  {
    id: 76115,
    name: 'Microsoft Technologies',
  },
  {
    id: 76117,
    name: 'Microsoft Word',
  },
  {
    id: 76233,
    name: 'Mobile Games',
  },
  {
    id: 76236,
    name: 'Mobile Internet',
  },
  {
    id: 76331,
    name: 'Motion Graphic Design',
  },
  {
    id: 76332,
    name: 'Motion Graphics',
  },
  {
    id: 76461,
    name: 'MySQL Cluster',
  },
  {
    id: 77691,
    name: 'PHP Applications',
  },
  {
    id: 77692,
    name: 'PHP Frameworks',
  },
  {
    id: 77718,
    name: 'PKCS',
  },
  {
    id: 77819,
    name: 'PTS',
  },
  {
    id: 78003,
    name: 'Pdf',
  },
  {
    id: 78478,
    name: 'Premiere',
  },
  {
    id: 78551,
    name: 'Procurement',
  },
  {
    id: 78611,
    name: 'Project Coordination',
  },
  {
    id: 78623,
    name: 'Project Purchasing',
  },
  {
    id: 78731,
    name: 'Purchasing Negotiation',
  },
  {
    id: 78732,
    name: 'Purchasing Processes',
  },
  {
    id: 78754,
    name: 'QC Tools',
  },
  {
    id: 78762,
    name: 'Quality Control',
  },
  {
    id: 78892,
    name: 'RNO',
  },
  {
    id: 79450,
    name: 'Routers',
  },
  {
    id: 79519,
    name: 'SAP',
  },
  {
    id: 79523,
    name: 'SAP BI',
  },
  {
    id: 79839,
    name: 'STLC',
  },
  {
    id: 79914,
    name: 'Sales Management',
  },
  {
    id: 80097,
    name: 'Selenium',
  },
  {
    id: 80098,
    name: 'Selenium Testing',
  },
  {
    id: 80496,
    name: 'Social Media Marketing',
  },
  {
    id: 80604,
    name: 'Sony Vegas Video',
  },
  {
    id: 80677,
    name: 'Spine',
  },
  {
    id: 80720,
    name: 'Spring MVC',
  },
  {
    id: 80928,
    name: 'Sumif',
  },
  {
    id: 81368,
    name: 'Tax Accounting',
  },
  {
    id: 82144,
    name: 'User Research',
  },
  {
    id: 82246,
    name: 'VPN',
  },
  {
    id: 82446,
    name: 'Video Editing',
  },
  {
    id: 82585,
    name: 'Vray',
  },
  {
    id: 82659,
    name: 'WPF',
  },
  {
    id: 82686,
    name: 'Wacom Tablet',
  },
  {
    id: 82900,
    name: 'Wholesale Purchasing',
  },
  {
    id: 82944,
    name: 'WinForms',
  },
  {
    id: 83227,
    name: 'YouTube',
  },
  {
    id: 83484,
    name: '',
  },
  {
    id: 84873,
    name: 'ANOVA',
  },
  {
    id: 84947,
    name: 'ASP.NET MVC',
  },
  {
    id: 85039,
    name: 'Academic Development',
  },
  {
    id: 85040,
    name: 'Academic Editing',
  },
  {
    id: 85041,
    name: 'Academic English',
  },
  {
    id: 85062,
    name: 'Account Management',
  },
  {
    id: 85138,
    name: 'Adaptive Learning',
  },
  {
    id: 85167,
    name: 'Administration',
  },
  {
    id: 85211,
    name: 'Advertising Sales',
  },
  {
    id: 85257,
    name: 'After Effects',
  },
  {
    id: 101564,
    name: 'xCAT',
  },
  {
    id: 101565,
    name: 'xCP',
  },
  {
    id: 101566,
    name: 'xPC Target',
  },
  {
    id: 101567,
    name: 'xPON',
  },
  {
    id: 101568,
    name: 'xPression',
  },
  {
    id: 101569,
    name: 'xSeries',
  },
  {
    id: 101570,
    name: 'xUnit',
  },
  {
    id: 101571,
    name: 'zLinux',
  },
  {
    id: 101572,
    name: 'zSeries',
  },
  {
    id: 105596,
    name: '105457',
  },
  {
    id: 105597,
    name: 'developer',
  },
  {
    id: 105598,
    name: 'Frontend',
  },
  {
    id: 105599,
    name: 'React Native Developer',
  },
  {
    id: 105600,
    name: 'Software Tester',
  },
  {
    id: 105601,
    name: 'Back-end Developer',
  },
  {
    id: 105602,
    name: 'bảo hiểm',
  },
  {
    id: 105603,
    name: 'Pháp lý',
  },
  {
    id: 105604,
    name: 'Luật đất đai',
  },
  {
    id: 105605,
    name: 'Legal',
  },
  {
    id: 105606,
    name: 'Bất động sản',
  },
];
